import { computed, get } from '@ember/object';

export default function pristine(key) {
  return computed(key, 'hasDirtyAttributes', function () {
    let changed = this.hasDirtyAttributes && this.changedAttributes()[key];
    return !changed ? get(this, key) : changed[0];
  });
}
